import React from 'react'
import Header from '../Header/Header'
function HomePage(props) {
    return (
        <div>
            <Header {...props} />
            
        </div>
    )
}

export default HomePage
